import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

import { NearByV4Response, OfficeSearchApiResponse } from '@src/lib/__generated/api';

type Facility = OfficeSearchApiResponse | NearByV4Response;

type State = {
	facility: Facility | null;
};

type Actions = {
	setFacility: (facility: Facility) => void;
};

const useFacilityStore = create<State & Actions>((set) => ({
	facility: null,
	setFacility: (facility) => set({ facility }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('facilityStore', useFacilityStore);
}

export default useFacilityStore;
